const CONSUMER_API_HOST =
  process.env.VUE_APP_PAYJOY_API_HOST || "https://vm.corp.payjoy.com";
const CONSUMER_API_BASE_URL = `${CONSUMER_API_HOST}/consumer/creditline`;

export const coreAppOnboardingApiUrls = (): Record<string, string> => {
  return {
    // In store onboarding
    GET_APPLICATION_FROM_REG_TAG: `${CONSUMER_API_BASE_URL}/instore/application/ongoing/from-registration-tag`,
    INIT_PERSON_REG: `${CONSUMER_API_BASE_URL}/instore/person-registration/init`,
    VALIDATE_PERSON_REG: `${CONSUMER_API_BASE_URL}/instore/person-registration/validate`,
    CREDIT_CHECK_PERMISSION: `${CONSUMER_API_BASE_URL}/instore/credit-pull/get-document`,
    ACCEPT_SIGNATURE: `${CONSUMER_API_BASE_URL}/instore/credit-pull/accept-signature`,
    CHECK_APPLICATION_SOURCE: `${CONSUMER_API_BASE_URL}/instore/check-application-source`,
    UPDATE_APPLICATION_SOURCE: `${CONSUMER_API_BASE_URL}/instore/update-application-source`,
    VALIDATE_KIOSK_ID: `${CONSUMER_API_BASE_URL}/instore/validate-kiosk-id`,
    CHECK_PRIOR_BORROWER: `${CONSUMER_API_BASE_URL}/instore/is-prior-borrower`,
    LOG_EVENT: `${CONSUMER_API_BASE_URL}/instore/log-event`,
  };
};

export const getPathNameFromUrl = (inputUrl: string): string => {
  return new URL(inputUrl).pathname;
};
